

import styles from './Mana.module.scss'
import classNames from "classnames";


type Props = {
  size?: number
  color?: string
  colors?: string[] | string
  className?: string,
  pid?: string,
  lengthIndex?: number,
}

const ALIAS_MAP: Record<string, string> = {
  't': 'tap',
  'q': 'untap',
}
const Mana = ({ color, colors, size, className, pid, lengthIndex }: Props) => {
  const lowerColor = color?.toLowerCase()
  const lowerColors = Array.isArray(colors) ? colors?.map((c) => c.toLowerCase()) : colors?.toLowerCase()

  const iter = lowerColor
    ? [lowerColor.replace('/', '')]
    : lowerColor === '' ? ['']
      : lowerColors?.length === 0
      ? ['c']
      : Array.isArray(lowerColors)
        ? lowerColors
        : (lowerColors || '').split('')

  return (
    <>
      {iter.map((colorItem) => (
        <span key={colorItem} className={className}>
          <i className={classNames(`ms ms-cost`, colorItem && `ms-${ALIAS_MAP[colorItem] || colorItem}`, styles[`textSize${lengthIndex}`])} style={size ? {height: size, width: size}: {}} />
        </span>
      ))}
    </>
  )
}

export default Mana
